import { createAnonymousUserSession } from '@wegic/common/anonymous';
import { userRequest } from '@/services/request';

interface AnonymousUserResponse {
  userId: string;
  anonymous: boolean;
  isNew: boolean;
}

const anonymousSession = createAnonymousUserSession({
  createAnonymousUserByDeviceId: async deviceId => {
    const { data } = await userRequest.post<AnonymousUserResponse>(
      '/anonymous',
      { deviceId },
      {
        hideCodeErrorMessage: true,
        hideHTTPErrorMessage: true,
      },
    );

    return data?.userId;
  },
  onError: error => {
    console.error('init anonymous user failed:', error);
  },
});

export function clearBuilderAnonymousUser() {
  anonymousSession.clearAnonymousUser();
}

export function initAnonymousUser(): Promise<string | null> {
  return anonymousSession.initAnonymousUser();
}
